// import React, { useState } from "react";
// import { Grid, TextField, Button, Box } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { createOrder } from "../../../Redux/Customers/Order/Action";
// import AddressCard from "../adreess/AdreessCard";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// export default function AddDeliveryAddressForm({ handleNext }) {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const jwt = localStorage.getItem("jwt");
//   const { auth } = useSelector((store) => store);
//   const [selectedAddress, setSelectedAddress] = useState(null);

//   // Handle form submit to add a new address
//   const handleSubmit = (event) => {
//     event.preventDefault();
//     const data = new FormData(event.currentTarget);

//     const address = {
//       firstName: data.get("firstName"),
//       lastName: data.get("lastName"),
//       streetAddress: data.get("address"),
//       city: data.get("city"),
//       state: data.get("state"),
//       zipCode: data.get("zip"),
//       mobile: data.get("phoneNumber"),
//     };

//     setSelectedAddress(address); // Set the newly added address as selected
//     toast.success("Address saved successfully!"); // Show success toast
//   };

//   // Handle address card selection
//   const handleSelectAddress = (item) => {
//     setSelectedAddress(item); // Set selected address
//     toast.info(` Address selected. Please processed to Payment: ${item.streetAddress}`); // Show toast when an address is selected
//   };

//   // Proceed to payment when an address is selected
//   const handlePaymentClick = () => {
//     if (selectedAddress) {
//       dispatch(createOrder({ address: selectedAddress, jwt, navigate }));
//       handleNext(); // Proceed to the next step
//     } else {
//       toast.error("Please select an address before proceeding to payment."); // Show error toast
//     }
//   };

//   return (
//     <>
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar={true} />
//       <Grid container spacing={4}>
//         <Grid item xs={12} lg={5}>
//           <Box className="border rounded-md shadow-md h-[30.5rem] overflow-y-scroll">
//             {auth.user?.addresses.map((item) => (
//               <div
//                 key={item.id}
//                 onClick={() => handleSelectAddress(item)}
//                 className={`p-5 py-7 border-b cursor-pointer ${
//                   selectedAddress?.id === item.id 
//                 }`} 
//               >
//                 <AddressCard address={item} />
//                 {selectedAddress?.id === item.id && (
//                   <Button
//                     sx={{ mt: 2 }}
//                     size="large"
//                     variant="contained"
//                     color="primary"
//                   >
//                     Address Selected
//                   </Button>
//                 )}
//               </div>
//             ))}
//           </Box>
//         </Grid>
//         <Grid item xs={12} lg={7}>
//           <Box className="border rounded-md shadow-md p-5">
//             <form onSubmit={handleSubmit}>
//               <Grid container spacing={3}>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     required
//                     id="firstName"
//                     name="firstName"
//                     label="First Name"
//                     fullWidth
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     required
//                     id="lastName"
//                     name="lastName"
//                     label="Last Name"
//                     fullWidth
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <TextField
//                     required
//                     id="address"
//                     name="address"
//                     label="Address"
//                     fullWidth
//                     multiline
//                     rows={4}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     required
//                     id="city"
//                     name="city"
//                     label="City"
//                     fullWidth
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     required
//                     id="state"
//                     name="state"
//                     label="State"
//                     fullWidth
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     required
//                     id="zip"
//                     name="zip"
//                     label="Zip / Postal code"
//                     fullWidth
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     required
//                     id="phoneNumber"
//                     name="phoneNumber"
//                     label="Phone Number"
//                     fullWidth
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Button
//                     sx={{ padding: ".9rem 1.5rem" }}
//                     size="large"
//                     type="submit"
//                     variant="contained"
//                     color="primary"
//                   >
//                     Save Address
//                   </Button>
//                 </Grid>
//               </Grid>
//             </form>
//           </Box>
//         </Grid>
//         <Grid item xs={12}>
//           <Button
//             sx={{ padding: ".9rem 1.5rem" }}
//             size="large"
//             variant="contained"
//             color="secondary"
//             onClick={handlePaymentClick}
//           >
//             Proceed to Payment
//           </Button>
//         </Grid>
//       </Grid>
//     </>
//   );
// }







import React, { useState, useEffect } from "react";
import { Grid, TextField, Button, Box, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createOrder } from "../../../Redux/Customers/Order/Action";
import AddressCard from "../adreess/AdreessCard";
import {toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

import { API_BASE_URL } from '../../../config/api';
import DeleteIcon from "@mui/icons-material/Delete";

export default function AddDeliveryAddressForm({ handleNext }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");
  const { auth } = useSelector((store) => store);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [addresses, setAddresses] = useState([]);

  // Fetch user addresses from backend
  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/address/`, {
          headers: { Authorization: `Bearer ${jwt}` },
        });
        setAddresses(response.data.addresses);
      } catch (error) {
        // toast.error("Failed to load addresses.");
        console.log("Failed to load addresses.")
      }
    };

    fetchAddresses();
  }, [jwt]);

  // Handle form submit to add a new address
  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const address = {
      firstName: data.get("firstName"),
      lastName: data.get("lastName"),
      streetAddress: data.get("address"),
      city: data.get("city"),
      state: data.get("state"),
      zipCode: data.get("zip"),
      mobile: data.get("phoneNumber"),
    };

    try {
      const response = await axios.post(`${API_BASE_URL}/api/address/add`, address, {
        headers: { Authorization: `Bearer ${jwt}` },
      });
      setAddresses([...addresses, response.data.address]); // Update local state
      setSelectedAddress(response.data.address); // Set newly added address
      toast.success("Address saved successfully!");
    } catch (error) {
      toast.error("Failed to save address.");
    }
  };

  // Handle address deletion
  const handleDeleteAddress = async (id) => {
    try {
      await axios.delete(`${API_BASE_URL}/api/address/${id}`, {
        headers: { Authorization: `Bearer ${jwt}` },
      });
      setAddresses(addresses.filter((addr) => addr._id !== id)); // Update state
      if (selectedAddress?._id === id) setSelectedAddress(null); // Deselect if deleted
      toast.success("Address deleted successfully.");
    } catch (error) {
      toast.error("Failed to delete address.");
    }
  };

  // Handle address card selection
  const handleSelectAddress = (item) => {
    setSelectedAddress(item);
    toast.info(`Address selected: ${item.streetAddress}`);
  };

  // Proceed to payment when an address is selected
  const handlePaymentClick = () => {
    if (selectedAddress) {
      dispatch(createOrder({ address: selectedAddress, jwt, navigate }));
      handleNext(); // Proceed to the next step
    } else {
      toast.error("Please select an address before proceeding.");
    }
  };

  return (
    <>
      {/* <ToastContainer position="top-right" autoClose={3000} hideProgressBar={true} /> */}
      <Grid container spacing={4}>
        <Grid item xs={12} lg={5}>
          <Box className="border rounded-md shadow-md h-[30.5rem] overflow-y-scroll">
            {addresses&&addresses.length>0?
            addresses.map((item) => (
              <div
                key={item._id}
                className={`p-5 py-7 border-b flex justify-between items-center cursor-pointer ${
                  selectedAddress?._id === item._id ? "bg-gray-100" : ""
                }`}
              >
                <div onClick={() => handleSelectAddress(item)}>
                  <AddressCard address={item} />
                </div>
                <IconButton color="error" onClick={() => handleDeleteAddress(item._id)}>
                  <DeleteIcon />
                </IconButton>
              </div>
            )):null
          }
          </Box>
        </Grid>
  
        <Grid item xs={12} lg={7}>
          <Box className="border rounded-md shadow-md p-5">
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    name="firstName"
                    label="First Name"
                    fullWidth
                    sx={{
                      '& label.Mui-focused': { color: '#854d0e' },
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                          borderColor: '#854d0e',
                        },
                      },
                    }}
                  />
                </Grid>
  
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    name="lastName"
                    label="Last Name"
                    fullWidth
                    sx={{
                      '& label.Mui-focused': { color: '#854d0e' },
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                          borderColor: '#854d0e',
                        },
                      },
                    }}
                  />
                </Grid>
  
                <Grid item xs={12}>
                  <TextField
                    required
                    name="address"
                    label="Address"
                    fullWidth
                    multiline
                    rows={4}
                    sx={{
                      '& label.Mui-focused': { color: '#854d0e' },
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                          borderColor: '#854d0e',
                        },
                      },
                    }}
                  />
                </Grid>
  
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    name="city"
                    label="City"
                    fullWidth
                    sx={{
                      '& label.Mui-focused': { color: '#854d0e' },
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                          borderColor: '#854d0e',
                        },
                      },
                    }}
                  />
                </Grid>
  
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    name="state"
                    label="State"
                    fullWidth
                    sx={{
                      '& label.Mui-focused': { color: '#854d0e' },
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                          borderColor: '#854d0e',
                        },
                      },
                    }}
                  />
                </Grid>
  
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    name="zip"
                    label="Zip / Postal code"
                    fullWidth
                    sx={{
                      '& label.Mui-focused': { color: '#854d0e' },
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                          borderColor: '#854d0e',
                        },
                      },
                    }}
                  />
                </Grid>
  
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    name="phoneNumber"
                    label="Phone Number"
                    fullWidth
                    sx={{
                      '& label.Mui-focused': { color: '#854d0e' },
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                          borderColor: '#854d0e',
                        },
                      },
                    }}
                  />
                </Grid>
  
                <Grid item xs={12}>
                  <Button
                    sx={{
                      padding: ".9rem 1.5rem",
                      backgroundColor: "#854d0e",
                      '&:hover': {
                        backgroundColor: "#a16212",
                      },
                    }}
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Save Address
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Grid>
  
        <Grid item xs={12}>
          <Button
            sx={{
              padding: ".9rem 1.5rem",
              backgroundColor: "#854d0e",
              '&:hover': {
                backgroundColor: "#a16212",
              },
            }}
            size="large"
            variant="contained"
            onClick={handlePaymentClick}
          >
            Proceed to Payment
          </Button>
        </Grid>
      </Grid>
    </>
  );
}  